module.exports = __webpack_public_path__ + "img/res.16846b76.png";